import dayjs from 'dayjs'
import { ColumnKind, FilterOperator } from './schemas'

export function isDateComparison(kind: ColumnKind | undefined, operator: string) {
  return (
    kind === ColumnKind.Date &&
    [FilterOperator.Equals, FilterOperator.Greater, FilterOperator.AtLeast, FilterOperator.Less, FilterOperator.AtMost].some((value) => value === operator)
  )
}

export function parseFilterDate(value: string) {
  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
  const display = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value)
  if (!iso && !display) return null
  const year = Number(iso ? iso[1] : display![3])
  const month = Number(iso ? iso[2] : display![1])
  const day = Number(iso ? iso[3] : display![2])
  const date = dayjs()
    .date(1)
    .year(year)
    .month(month - 1)
    .date(day)
    .startOf('day')
  return year >= 1 && date.year() === year && date.month() === month - 1 && date.date() === day ? date : null
}
